/**
 * Bundled Tabs Configuration
 * 
 * Auto-generated at build time from public/UserData/wedding-tabs-config.json
 * DO NOT EDIT THIS FILE MANUALLY
 * 
 * Generated at: 2026-03-06T15:16:07.612Z
 */

export const bundledTabsConfig = {
  "type": "tabs",
  "floorplanFileName": "floorplan.png",
  "menuFileName": "menu.png",
  "showVenueTab": true,
  "showMediaFilter": true,
  "showGuestbookTab": true,
  "showQAndATab": true
};

export default bundledTabsConfig;
